import React from "react";
const icon = (
  <svg
    width="448"
    height="512"
    viewBox="0 0 448 512"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 64C0 46.3 14.3 32 32 32H80H128C145.7 32 160 46.3 160 64C160 81.7 145.7 96 128 96H112V208H336V96H320C302.3 96 288 81.7 288 64C288 46.3 302.3 32 320 32H368H416C433.7 32 448 46.3 448 64C448 81.7 433.7 96 416 96H400V240V416H416C433.7 416 448 430.3 448 448C448 465.7 433.7 480 416 480H368H320C302.3 480 288 465.7 288 448C288 430.3 302.3 416 320 416H336V272H112V416H128C145.7 416 160 430.3 160 448C160 465.7 145.7 480 128 480H80H32C14.3 480 0 465.7 0 448C0 430.3 14.3 416 32 416H48V240V96H32C14.3 96 0 81.7 0 64Z"
      fill="#8803E9"
    />
  </svg>
);

export default icon;
